import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function dialogOpenReducer(
  state = initialState.dialogOpen,
  action
) {
  switch (action.type) {
    case types.LOADED_DIALOG_OPEN_SUCCESS:
      return action.dialogOpen;
    default:
      return state;
  }
}
